const GLOBAL = {
    VARIABLES: {
        // LOGGINGAPIURL: "https://elmloggingapi-dev.azurewebsites.net", //DEV
        // LOGGINGAPIURL: "https://elmloggingapi.azurewebsites.net", // PROD
        LOGGINGAPIURL : process.env.REACT_APP_LOGGING_API_URL,
        LOG_NAME: "LPPortal",
        LOGGING_USERNAME: 'svc.swglla',
        LOGGING_PASSWORD: 'swglla4elm!',
    },
    CONFIGSETTINGS : {
        LogSetting : {
            LOG_LEVEL: -1,
            UPLOAD_LOG_DURATION: 30000,
            LOG_ENABLED: true,
        }
    }
}

export default GLOBAL;